import styled, { css } from 'styled-components/macro';
import { TooltipContentDiv } from '../../../components/TooltipContentStyles';
import Card from '../../../components/Card';
import { textLinkBase } from '../../../components/LinkStyles';
import { DefaultIcon } from '../../../components/Icon';

export const InformationDiv = styled.div`
  @media screen and (min-width: 768px) {
    padding: 0px;
  }
`;

export const BasicInfoCard = styled(Card)`
  margin-top: 34px;
  min-height: 238px;
  width: 100%;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  position: relative;
  padding-left: 54px;
  border-top: none;
  padding: 5rem;
  @media screen and (min-width: 1024px) {
    padding-left: 80px;
  }
  &:hover {
    outline: 1px solid ${props => props.theme.blue};
  }
`;

export const BasicInfoAccountImg = styled.img`
  width: 78px;
  height: 78px;
  margin-right: 35px;
  /* position: absolute; */
  /* display: inline-block; */
`;

export const BasicInfoContentDiv = styled.div`
  /* display: inline-block; */
`;

export const BasinInfoLineDiv = styled.div`
  h5 {
    width: 88px;
  }
  @media screen and (min-width: 768px) {
    display: flex;
    margin: 0.8rem;
    /* margin-left: 145px; */
  }
`;

export const BasicInfoP = styled.p`
  margin-top: 6px;
  margin-bottom: 1rem;
  ${props =>
    props.disabled &&
    css`
      color: ${props => props.theme.mercury};
    `}

  @media screen and (min-width: 768px) {
    margin: 0px;
    margin-left: 30px;
  }
`;

export const ChangePasswordP = styled.p`
  margin-left: 25px;
  ${textLinkBase}
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  svg {
    margin-right: 5px;
    height: 12px;
    width: 12px;
  }
`;

export const BasicInfoFormCard = styled(Card)`
  padding: 7rem 3rem 9rem;
  min-height: auto;
  @media screen and (min-width: 768px) {
    padding: 7rem 10rem 9rem;
  }
`;

export const BasicInfoFormForm = styled.form`
  max-width: 800px;
  @media screen and (min-width: 1440px) {
    display: flex;
    flex-direction: row;
  }
`;

export const BasicInfoFormFieldDiv = styled.div`
  @media screen and (min-width: 1440px) {
    width: 303px;
    margin-right: 70px;
  }
`;

// PartnerInfoBlock
export const PartnerInfoCard = styled(Card)`
  ${props => props.theme.defaultDropShadow};
  padding: 0 3rem;
  margin-top: 16px;
  min-height: auto;
  border-top: none;

  @media screen and (min-width: 768px) {
    padding: 4rem;
  }
  @media screen and (min-width: 1024px) {
    padding: 4rem 6rem;
  }
`;

const infoBlockHeightLg = '120px';
export const PartnerInfoBigBlockDiv = styled.div`
  border-bottom: 1px solid ${props => props.theme.mercury};

  @media screen and (min-width: 768px) {
    width: 50%;
    display: inline-block;
    border-bottom: none;
    border-right: 1px solid ${props => props.theme.mercury};
    padding: 20px 0;
  }
  @media screen and (min-width: 1440px) {
    padding: 0;
    height: ${infoBlockHeightLg};
  }
`;

export const PartnerInfoBigBlockH5 = styled.h5`
  > div {
    padding-left: 7px;
  }
  @media screen and (max-width: 530px) {
    width: 90px;
    height: 50px;
  }
`;

export const PartnerInfoBigBlockP = styled.p`
  margin-top: 10px;
  font-size: 3.5rem;
  line-height: 3.5rem;
  @media screen and (min-width: 768px) {
    font-size: 4.5rem;
    line-height: 4.5rem;
  }
`;

export const CommissionRateDiv = styled.div`
  display: inline-block;
  margin: 20px 0px;
  width: 50%;
  padding: 20px;
  &:first-child {
    padding: 20px 10px 20px 0;
    border-right: 1px solid ${props => props.theme.mercury};
  }

  @media screen and (min-width: 768px) and (max-width: 1439px) {
    width: 80%;
    display: block;
    margin: 0;
    padding-left: 0;
    &:first-child {
      padding-top: 0;
      border-right: none;
      border-bottom: 1px solid ${props => props.theme.mercury};
    }
  }
  @media screen and (min-width: 1440px) {
    margin: 0;
    padding: 0;
    display: inline-flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    &:last-child {
      padding-left: 20px;
    }
  }
`;

export const PartnerInfoSmallBlockDiv = styled.div`
  padding: 2rem 0;

  @media screen and (min-width: 768px) {
    display: inline-block;
    width: 50%;
    padding-left: 3rem;
  }
  @media screen and (min-width: 1024px) {
    padding-left: 6rem;
  }
  @media screen and (min-width: 1440px) {
    padding-top: 2rem;
    padding-bottom: 0;
  }
`;

export const PartnerInfoDefaultMerchantFeeH5 = styled.h5`
  > div {
    padding-left: 7px;
  }
  padding: 10px 0 8px 0;
  border-bottom: 1px solid ${props => props.theme.mercury};
  @media screen and (min-width: 768px) {
    padding-top: 0;
    padding-bottom: 8px;
  }
`;

export const PartnerInfoMerchantFeesDiv = styled.div`
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
  p {
    margin-left: 10px;
    line-height: 2rem;
  }
`;

export const InfoIconDiv = styled.div`
  position: relative;
  display: inline-block;
  transform: translateY(-1px);
  ${TooltipContentDiv} {
    position: absolute;
    bottom: 35px;
    left: -80px;
  }
`;

export const ContractInfoH5 = styled.h5`
  /* height: 15px; */
`;

export const ContractInfoP = styled.p`
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 15px;

  @media screen and (min-width: 768px) {
    font-size: 23px;
    padding-bottom: 3px;
  }
`;

export const ContractAgreementP = styled(ContractInfoP)`
  color: ${props => props.theme.brand};
  ${props =>
    props.underline &&
    css`
      text-decoration: underline;
    `}
`;

export const CustomDefaultIcon = styled(DefaultIcon)`
  fill: ${props => props.theme.brand};
  height: 9px;
  width: 9px;
  margin-left: 6px;
`;
